module.exports = __webpack_public_path__ + "img/devB.f4f9f192.png";